import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule, UpperCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { FileExtensionPipe } from '@modules/attachments/pipes/file-extension.pipe';
import { AttachmentActionsService } from '@modules/attachments/services/attachment-actions.service';
import { ActionButtonsComponent } from '@modules/shared/action-buttons/action-buttons.component';
import { UserPreviewComponent } from '@modules/user/user-preview/user-preview.component';
import { EmptyStateComponent } from '@shared/components/empty-state/empty-state.component';
import { Attachment } from '@shared/models/attachments/attachment';
import { MenuAction } from '@shared/models/menu-actions/menu-action';
import { TuiTable } from '@taiga-ui/addon-table';
import { TuiScrollbar } from '@taiga-ui/core';
import { TuiCardLarge } from '@taiga-ui/layout';
import { AttachmentPreviewComponent } from '../attachment-preview/attachment-preview.component';
import { ATTACHMENT_TABLE_CONFIG } from './configurations/attachment-table.config';
import { TableHeader } from './models/table-header';
import { VirtualScrollBuffer } from './models/virtual-scroll-buffer';

@Component({
  selector: 'pxc-attachment-list',
  imports: [
    TuiCardLarge,
    CommonModule,
    TuiTable,
    TuiScrollbar,
    ScrollingModule,
    FileExtensionPipe,
    UpperCasePipe,
    UserPreviewComponent,
    ActionButtonsComponent,
    AttachmentPreviewComponent,
    TranslocoDirective,
    EmptyStateComponent,
  ],
  templateUrl: './attachment-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AttachmentListComponent {
  @Input() attachments: Attachment[];

  private readonly attachmentActionsService = inject(AttachmentActionsService);

  get virtualScroll(): VirtualScrollBuffer {
    return ATTACHMENT_TABLE_CONFIG.virtualScroll;
  }

  get tableHeaders(): TableHeader<Attachment>[] {
    return ATTACHMENT_TABLE_CONFIG.headers;
  }

  get columns(): string[] {
    return this.tableHeaders.map((th: TableHeader<Attachment>) => th.column);
  }

  get actions(): MenuAction<Attachment>[] {
    return this.attachmentActionsService.getActions();
  }

  trackByAttachment(index: number, item: Attachment): string {
    return `${index}-${item.id}`;
  }
}
